import React, { useEffect } from "react";
import { MEGA_MENU_ITEMS } from "../../constants/navigation.constants";
import { getIconSrc } from "../../constants/iconMap";
import { NavigationItem } from "../../types/header.types";
import "./MegaMenu.css";
import { track } from "../../../../services/analytics";

interface MegaMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MegaMenu: React.FC<MegaMenuProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    const headerElement = document.querySelector(".header");
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      headerElement?.classList.add("menu-open");
    } else {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      headerElement?.classList.remove("menu-open");
    }

    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
      headerElement?.classList.remove("menu-open");
    };
  }, [isOpen]);

  const renderMenuItem = (item: NavigationItem) => {
    const iconSrc = getIconSrc(item.icon);

    return (
      <div key={item.id} className="box-menu">
        <div className="title">
          {item.href ? (
            <a
              href={item.href}
              className="d-flex align-items-center"
              target={item.external ? "_blank" : undefined}
              rel={item.external ? "noopener noreferrer" : undefined}
              onClick={() => {
                if (item.id === "forluzgo") {
                  track("link_externo_clique", {
                    identificador: item.id,
                    categoria: "produto_forluz",
                  });
                }
                setTimeout(() => onClose(), 150);
              }}
            >
              {iconSrc && (
                <img src={iconSrc} alt={item.label} width="22" height="20" />
              )}
              <span>{item.label}</span>
            </a>
          ) : (
            <span className="d-flex align-items-center">
              {iconSrc && (
                <img src={iconSrc} alt={item.label} width="22" height="20" />
              )}
              <span>{item.label}</span>
            </span>
          )}
        </div>
        {item.children && (
          <ul>
            {item.children.map((child) => (
              <li key={child.id}>
                <a
                  href={child.href}
                  target={child.external ? "_blank" : undefined}
                  rel={child.external ? "noopener noreferrer" : undefined}
                  onClick={() => {
                    setTimeout(() => onClose(), 150);
                  }}
                >
                  {child.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  const getColumnItems = (columnIndex: number): NavigationItem[] => {
    const columnMap = {
      0: MEGA_MENU_ITEMS.slice(0, 4), // Coluna 1: A Forluz, Acontece na Forluz, Para Viver Melhor, ForluzGO! (índices 0-3)
      1: MEGA_MENU_ITEMS.slice(4, 8), // Coluna 2: Plano A, Plano B, Plano TaesaPrev (índices 4-6)
      2: MEGA_MENU_ITEMS.slice(8, 12), // Coluna 3: Investimentos, Empréstimos, Transparência, Governança/Riscos/Compliance (índices 8-11)
      3: MEGA_MENU_ITEMS.slice(12, 15), // Coluna 4: Central de Atendimento, Gestão de Pessoas, Formulários (índices 12-14)
    };

    return columnMap[columnIndex as keyof typeof columnMap] || [];
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    const handleEscKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [isOpen, onClose]);

  return (
    <div
      className={`header__mega-menu ${isOpen ? "active" : ""}`}
      onClick={handleOverlayClick}
    >
      {/* Mega Menu topo */}
      <div className="topo">
        <div className="header-full-width">
          <div className="row">
            <div className="col-12">
              {/* Fechar Menu */}
              <button
                onClick={onClose}
                className="btn btn-outline-white btn-icon btn-close rounded transition py-2 px-4"
                aria-label="Fechar menu"
              >
                <img
                  src={getIconSrc("close.svg")}
                  alt="Fechar menu"
                  width="14"
                  height="14"
                  className="mr-3"
                />
                <span>Fechar</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mega Menu content */}
      <div className="content" onClick={(e) => e.stopPropagation()}>
        <div className="header-full-width">
          <div className="row">
            {/* Coluna 1 */}
            <div className="col-lg-3 menu-column">
              {getColumnItems(0).map((item) => renderMenuItem(item))}
            </div>

            {/* Coluna 2 */}
            <div className="col-lg-3 menu-column">
              {getColumnItems(1).map((item) => renderMenuItem(item))}
            </div>

            {/* Coluna 3 */}
            <div className="col-lg-3 menu-column">
              {getColumnItems(2).map((item) => renderMenuItem(item))}
            </div>

            {/* Coluna 4 */}
            <div className="col-lg-3 menu-column">
              {getColumnItems(3).map((item) => renderMenuItem(item))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
